// @flow
import storage from 'redux-persist/lib/storage';

export default {
  key: 'root',
  storage,
  whitelist: ['auth'],
};



// WEBPACK FOOTER //
// ./src/scripts/store/persistorConfiguration.js